import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TYPOGRAPHY_STYLE } from 'radiance-ui';
import { SPACER } from 'radiance-ui/lib/constants';

export const BodyTitle = styled.h3`
  ${({ theme }) => TYPOGRAPHY_STYLE.title(theme)};
  margin-bottom: ${SPACER.medium};
`;

export const CtaContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: ${SPACER.xlarge};

  button:last-of-type {
    margin-top: ${SPACER.large};
  }
`;

export const modalHeaderImageStyles = css`
  width: 100%;
  object-fit: cover;
  object-position: 50% 60%;
`;
